let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kLydq")).then(() => parcelRequire('dXKzb'));